
export const Select = ({ name = 'category', children, label, onChange, value, className = "", hiddenDefaultValue = false, variant = "simple", divClass }) => {

    const css = variant === "rounded"
        ? `mt-1 w-full text-sm px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10 ${className}`
        : `border-2 border-gray-300 text-sm px-2 py-2 text-gray-700 bg-white border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`

    return (
        <div className={`flex flex-col ${divClass}`}>
            <label htmlFor="category" className="text-sm text-gray-500">
                {label}
            </label>
            <select
                onChange={onChange}
                value={value}
                id={name}
                name={name}
                className={css}
            >
                {!hiddenDefaultValue && <option value="">Selecione</option>}
                {children}
            </select>
        </div>
    );
};